module.exports = {
    FR : "fr"
}